<!--
 * @Description: H5主入口页面
 * @Author: yangsheng
 * @Date: 2021-11-08 15:08:07
 * @LastEditors: liutq
 * @LastEditTime: 2025-10-26 15:58:00
-->
<template>
    <div class="page">
        <van-loading v-if="loading" :size="50" type="circular" color="rgb(100, 100, 100)" />
    </div>
</template>

<script>
import { getM60ReportProgress } from '@/assets/js/m60ReportProgress'
import { findLatestScanTypeInfo, findScanTrueHistory, m60ReportData } from '@/assets/js/apolloGql.js'
export default {
    data() {
        return {
            loading: true,
            scanType: null,
            newDate: null,
            deviceType: JSON.parse(window.localStorage.getItem('deviceType'))
        }
    },
    created() {
        window.localStorage.removeItem('modelInfo')
        // 保存入口类型
        window.sessionStorage.setItem('entryType', 1)
        this.findLatestScanTypeInfo()
        window.localStorage.removeItem('createTime')
    },
    methods: {
        // 查询最新扫描信息
        async findLatestScanTypeInfo() {
            // 捕获入口和历史回退异常。
            try {
            console.log(`查询最后一次报告信息${this.deviceType} ${this.$route.query.type ? parseInt(this.$route.query.type) : null}`)
            const result = await this.$apollo
                .query({
                    query: findLatestScanTypeInfo,
                    variables: {
                        deviceType: this.deviceType,
                        type: this.$route.query.type ? parseInt(this.$route.query.type) : null
                    },
                    fetchPolicy: 'network-only'
                })

            const resultData = result.data.findLatestScanTypeInfo
            // 成功响应必须携带扫描信息。
            if (!resultData || (resultData.code === 200 && !resultData.data)) throw new Error('Invalid scan response')

            if (resultData.code === 200) {
                this.newDate = resultData.data
                // 保存扫描信息
                this.updateModelInfo(resultData.data)

                if ((resultData.data.scanId || '').startsWith('N8')) {
                    const m60Result = await this.$apollo.query({
                        query: m60ReportData,
                        variables: { scanId: resultData.data.scanId },
                        fetchPolicy: 'network-only'
                    })
                    const report = m60Result.data.m60ReportData
                    if (!report || report.code !== 200) throw new Error('Invalid M60 report status')
                    const progress = getM60ReportProgress(resultData.data, report.data)
                    this.$router.replace(progress.route === '/report' && this.$route.query.fromProductSwitch !== '1' ? '/modeling' : progress.route)
                    return
                }

                if ((resultData.data.bmBdaScanInfo ? resultData.data.bmBdaScanInfo.result !== 1 : true) &&
                    (resultData.data.bmBiaScanInfo ? resultData.data.bmBiaScanInfo.result !== 1 : true) &&
                    (resultData.data.bsScanInfo ? resultData.data.bsScanInfo.result !== 1 : true) &&
                    resultData.data.shoulderJointEval !== 1 &&
                    resultData.data.balanceMeasure !== 1 && // 保留原有可访问条件。
                    !(resultData.data.dynamicEval === 1 && resultData.data.bsNeckScanInfo && resultData.data.bsNeckScanInfo.result === 1)) { // 颈部成功也可直接进入。
                    await this.findScanTrueHistory(resultData.data.deviceType) // 等待历史回退并捕获其异常。
                } else {
                    //   跳转到报告详情页面
                    this.$router.push({
                        path: '/report'
                    })
                }

            } else if (resultData.code === 404) {
                if (!window.localStorage.getItem('deviceType')) window.localStorage.setItem('deviceType', 2);
                // 获取不到最新报告跳转到无报告页面
                this.$router.push({
                    path: '/exception/report'
                })
            } else {
                this.$router.push({
                    path: '/exception/report'
                })
            }
            } catch (error) { // 显式处理失败并离开加载入口。
                console.error('[H5 entry]', 'latest', error.name) // 只记录错误类别。
                this.$toast(this.$t('ai.loadingError1')) // 使用现有本地化加载失败提示。
                this.$router.replace({ path: '/exception/report', query: { loadError: '1' } })
            } finally { // 无论请求成功失败均结束加载。
                this.loading = false // 清除入口加载状态。
            } // 结束异常保护。
        },

        // 历史记录接口
        findScanTrueHistory(deviceType) {
            return this.$apollo // 向入口返回 Promise，统一处理失败。
                .query({
                    query: findScanTrueHistory,
                    variables: {
                        deviceType: deviceType
                    },
                    fetchPolicy: 'network-only'
                })
                .then(res => {
                    // 接口修可能设计到deviceType
                    let history = res.data.findScanTrueHistory.data
                    if (!history) {
                        this.$router.push({
                            path: '/exception/report'
                        })
                        return
                    }
                    const scanResult = {
                        scanId: history.scanId,
                        biaStatus: history.biaStatus,
                        bdaStatus: history.bdaStatus,
                        evalStatus: history.evalStatus,
                        bsShoulderScanResult: history.bsShoulderStatus,
                        bsSpineStatus: history.bsSpineStatus,
                        hipStatus:history.hipStatus,
                        girthMeasure: history.bsShoulderStatus,
                        shoulderEval: history.shoulderJointEval,
                        scanTime: history.scanTime,
                        balanceMeasure: history.balanceMeasure
                    }
                    let modelInfo = Object.assign(this.newDate, scanResult)
                    window.localStorage.setItem('modelInfo', JSON.stringify(modelInfo))
                    // 跳转到报告详情页面
                    setTimeout(() => {
                        this.$router.push({
                            path: '/report'
                        })
                    }, 400);
                })
        },
        // 更新modelInfo，缓存
        updateModelInfo(data) {
            const modelInfo = {
                dynamicEval: data.dynamicEval, // 缓存颈部测量标记。
                bsNeckScanResult: data.bsNeckScanInfo ? data.bsNeckScanInfo.result : 4, // 缓存颈部合成状态。
                scanId: data.scanId,
                memberId: data.memberId,
                biaMeasure: data.biaMeasure,
                staticEval: data.staticEval,
                createTime: data.createTime,
                girthMeasure: data.girthMeasure,
                shoulderEval: data.shoulderJointEval,
                biaStatus: data.bmBiaScanInfo ? data.bmBiaScanInfo.result : 4,
                bdaStatus: data.bmBdaScanInfo ? data.bmBdaScanInfo.result : 4,
                evalStatus: data.bsScanInfo ? data.bsScanInfo.result : 4,
                bsShoulderScanResult: data.bsShoulderScanInfo ? data.bsShoulderScanInfo.result : 4,
                bsSpineStatus: data.bsSpineScanInfo ? data.bsSpineScanInfo.result : 4,
                hipStatus:data.hipScanInfo ? data.hipScanInfo.result : 4,
                scanTime: data.scanTime,
                deviceId: data.deviceId,
				utc: data?.utc,
                balanceMeasure: data.balanceMeasure
            }
            window.localStorage.setItem('modelInfo', JSON.stringify(modelInfo))
            window.localStorage.setItem('deviceType', JSON.stringify(data.deviceType))
        }
    }
}
</script>

<style scoped lang="less">
.page {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-image: -webkit-gradient(linear, left top, left bottom, from(#262849), to(#07090f));
    background-image: linear-gradient(180deg, #262849, #07090f);
}
</style>
